//Angular inputs
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

const APP_PREFIX = 'nmfta_';

@Injectable({
  providedIn: 'root'
})
export class SessionStorageService {

  constructor(public router: Router) { }

  private getKey(key: string): string {
    return `${APP_PREFIX}${key}`;
  }

  setItem<T>(key: string, value: T): void {
    if (value) {
      window.sessionStorage.setItem(this.getKey(key), JSON.stringify(value));
    }
  }

  setPageState(route: string, page: number, pageSize: number) {
    const pageData = { page: page, pageSize: pageSize };
    this.setItem(this.getKey(route), JSON.stringify(pageData));
  }

  setPageFilterInputs(route: string, filters: string[][] = []) {
    this.setItem(route, JSON.stringify(filters));
  }

  getPageFilterInputs(route: string): string[][] {
    const returnValue = window.sessionStorage.getItem(`${APP_PREFIX}${route}`);
    return returnValue ? JSON.parse(JSON.parse(returnValue)) : [];
  }

  setPageFilterValue(route: string, filters: string) {
    this.setItem(route, JSON.stringify(filters));
  }

  getPageFilterValue(route: string): string {
    const returnValue = window.sessionStorage.getItem(`${APP_PREFIX}${route}`);
    return returnValue ? JSON.parse(JSON.parse(returnValue)) : "";
  }

  getItem<T>(key: string): T | null {
    const storedValue = window.sessionStorage.getItem(`${APP_PREFIX}${key}`);
    return storedValue ? JSON.parse(storedValue) : null;
  }

  getPageState(url: string): { page: number, pageSize: number } {
    const returnValue = window.sessionStorage.getItem(`${APP_PREFIX}${url}`);

    return returnValue ? JSON.parse(JSON.parse(returnValue)) : { page: 1, pageSize: 10 };
  }

  removeItem(key: string): void {
    const storageKey = this.getKey(key);
    if (window.sessionStorage.getItem(storageKey) !== null) {
      window.sessionStorage.removeItem(storageKey);
    }
  }

  clearAll(): void {
    Object.keys(sessionStorage)
      .filter((key) => key.startsWith(APP_PREFIX))
      .forEach((key) => sessionStorage.removeItem(key));
  }
}
